import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import Icon from "../../../components/Icon"

function UtgsInfoModal({ showSignal, handleCancel, referenceGuid}) {

	return (
		<Modal show={showSignal.value} onHide={handleCancel}>
			<Modal.Header closeButton>
				<Modal.Title>About UTGs</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>The UTGs tab displays a list of Universal Transaction Gateways that are currently, or at one point were, connected to Shift4 Command Center for this account. Click on the Component Nickname to view the details of the machine and information on any UTG running on the machine.</p>
				<br />
				<p>UTGs are automatically added when a Shift4 Command Center agent is installed on a machine running a UTG and connects to Shift4 Command Center. Once connected, the UTG will appear in the UTGs table in Shift4 Command Center. Information pertaining to the specific UTG will become available, along with the ability to Schedule Tasks for that UTG.</p>
				<br />
				<p>For more information, click <b>Reference Guide.</b></p>
			</Modal.Body>
			<Modal.Footer>
				<Button type="button" style={{ fill: "white" }} onClick={() => { window.open(referenceGuid) }}>
					<Icon icon="book" height={16} width={16}></Icon>&nbsp;&nbsp;Reference Guide
				</Button>
				<Button type="button" onClick={handleCancel}>Close</Button>
			</Modal.Footer>
		</Modal>
    )
}

export default UtgsInfoModal